import { Modal, Text, Group, Button, Stack } from "@mantine/core";
import { IconAlertTriangle } from "@tabler/icons-react";

interface UnsavedChangesModalProps {
  opened: boolean;
  onClose: () => void;
  onDiscard: () => void;
  onSave: () => void;
  isSaving?: boolean;
}

export default function UnsavedChangesModal({
  opened,
  onClose,
  onDiscard,
  onSave,
  isSaving = false,
}: UnsavedChangesModalProps) {
  return (
    <Modal
      opened={opened}
      onClose={onClose}
      title={
        <Group gap="xs">
          <IconAlertTriangle size={20} color="orange" />
          <Text fw={600}>Unsaved Changes</Text>
        </Group>
      }
      centered
      size={520}
    >
      <Stack gap="md">
        <Text>You have unsaved changes. What would you like to do?</Text>
        <Group justify="flex-end" gap="sm" wrap="nowrap">
          <Button variant="outline" onClick={onClose}>
            Cancel
          </Button>
          <Button color="red" variant="light" onClick={onDiscard}>
            Discard Changes
          </Button>
          <Button onClick={onSave} loading={isSaving}>
            Save Changes
          </Button>
        </Group>
      </Stack>
    </Modal>
  );
}
